/* eslint-disable react/prop-types */
import React from 'react';
import './StepProgress.css'; // on importe notre fichier CSS

function generateArray(n) {
  return Array.from({ length: n }, (_, i) => i + 1);
}

function StepProgress({
  currentStep = 1,
  length = 3,
}) {
  const steps = generateArray(length);

  return (
    <div className="step-container">
      <div className="step-points">
        {steps.map((step, index) => (
          <div
            key={`dots${(index / 2) * 2}`}
            className={`step-point ${currentStep === step ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
}

export default StepProgress;
